import { render, staticRenderFns } from "./a6.vue?vue&type=template&id=15e224d5&scoped=true"
import script from "./a6.vue?vue&type=script&lang=js"
export * from "./a6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e224d5",
  null
  
)

export default component.exports